import {
  monserratSemiBold,
  robotoRegular,
  scarpaGray25,
} from "@habitech/shared";
import styled from "styled-components";

export const WrapperVIM = styled.div`
  border-radius: 10px;
  .modal-title {
    font-size: 18px;
    font-family: ${monserratSemiBold};
    font-weight: 600;
  }
  .dropdown-title,
  .dropdown-item,
  .subtitle-card {
    font-size: 14px;
    font-family: ${robotoRegular};
    font-weight: 600;
  }
  .dropdown-toggle {
    font-size: 14px;
    font-family: ${robotoRegular};
    align-items: center;
    display: flex;
    justify-content: space-between;
    gap: 4px;
    background-color: rgb(99, 1, 204);
    border-color: rgb(99, 1, 204);
    padding-left: 14px;
    padding-right: 14px;
  }
  .change-card {
    font-size: 14px;
    border-radius: 5px;
    font-family: ${robotoRegular};
    font-weight: 600;
  }
  .title-card {
    font-size: 16px;
    font-family: ${monserratSemiBold};
    font-weight: 600;
    text-align: center;
  }
  .consequence-card,
  .visits-list {
    font-size: 14px;
    font-family: ${robotoRegular};
    font-weight: 600;
  }
  .visits-list {
    padding-left: 16px;
    margin: 0;
  }
  .consequence-card {
    background-color: ${scarpaGray25};
  }
  .bg-success {
    font-size: 12px;
    font-family: ${robotoRegular};
    font-weight: 600;
  }
  .dropdown-menu.show {
    overflow: scroll;
    max-height: 350px;
  }
  .current-price {
    font-size: 14px;
    font-family: ${robotoRegular};
    font-weight: 900;
  }
`;
